import './styles/vimeo-modal.css';

import { VimeoModalController } from '$utils/vimeo-modal';

window.Webflow ||= [];
window.Webflow.push(() => {
  const vimeoModalController = new VimeoModalController();
  vimeoModalController.init();
});
